import { atom, selector } from 'recoil'

export const langModelState = atom({
  key: 'LangAI/langModelState',
  default: [],
})

export const langModelListState = selector({
  key: 'LangAI/langModelListState',
  get: ({ get }) => {
    const data = get(langModelState);
    return Array.isArray(data) ? data : [];
  },
});